import { setError } from '../utilities/authentication/authenticationSlice';
import authenticationProvider from '../utilities/authentication/authenticationProvider';
import EpiContext from '@episerver/spa-core/Spa';
import helper from '../utilities/helper';

const redirectToLogin = (pathName, cancelUrl, template) => {
    let counter = 0;
    const clearAndRedirect = (interval) => {
        clearInterval(interval);
        authenticationProvider.redirectToLogin(pathName, cancelUrl, template);
    };

    const interval = setInterval(() => {
        if (window?.location?.pathname?.toLowerCase() === pathName?.toLowerCase()) clearAndRedirect(interval);

        counter++;
        if (counter >= 50) clearAndRedirect(interval);
    }, 100);
};

export default (store) => (next) => async (action) => {
    if (action.type === 'ADD_UPDATE_ICONTENT_ITEM' && /\b403\b/.test(action.item?.error?.value)) {
        let pathName = action.item?.contentLink?.url || '/';
        let cancelUrl = '';
        let template = helper.getLoginTemplate(pathName);

        next(setError(403, pathName, cancelUrl, template));
        if (window?.location?.pathname?.toLowerCase() === pathName?.toLowerCase()) {
            redirectToLogin(pathName, cancelUrl, template);
        }
    } else if (action.type === 'UPDATE_PATH') {
        const state = store.getState();
        if (
            state &&
            state.authentication &&
            state.authentication.error &&
            state.authentication.error.errorCode == '403' &&
            action.path === state.authentication.redirectData.pathName &&
            state.authentication.loginData.isFullAuthenticated === false
        )
            redirectToLogin(
                state.authentication.redirectData.pathName,
                state.authentication.redirectData.cancelUrl,
                state.authentication.redirectData.template
            );
    } else if (action.type === 'saleBlock/redirectToLogin') {
        var pathName = action.payload.returnUrl;
        var cancelUrl = action.payload.cancelUrl;
        var template = action.payload.template;
        authenticationProvider.redirectToLogin(pathName, cancelUrl, template, false);
        return;
    } else if (action.type === 'movingBlock/redirectToLogin') {
        var pathName = action.payload.returnUrl;
        var cancelUrl = action.payload.cancelUrl;
        var template = action.payload.template;
        authenticationProvider.redirectToLogin(pathName, cancelUrl, template, false);
        return;
    } else if (action.type === 'changePricePlan/redirectToLogin') {
        authenticationProvider.redirectToLogin(action.payload.returnUrl, action.payload.cancelUrl, action.payload.template, false);
        return;
    } else if (action.type === 'premiumPackagesCatalog/redirectToLogin') {
        authenticationProvider.redirectToLogin(action.payload.returnUrl, action.payload.cancelUrl, action.payload.template, false);
        return;
    }
    return next(action);
};
